import React, {Component} from "react"
import {Button, Checkbox, Container, Divider, Form, FormGroup, Header, Icon, List, Loader, Message, Modal, Select} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {getLocalization, interpolateString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {
    checkIsVerified,
    domesticPartnershipText,
    getStepProps,
    getTranslatedCoverageText,
    getTranslatedGenderText,
    getTranslatedPhoneTypeText,
    getTranslatedRelationshipText,
    getTranslatedStudentStatusText,
    handleSaveUserProgress,
    isAnsel,
    languages,
    spouseText,
    civilUnionText,
} from "../utils/common";
import Steps from "./steps/steps";
import {deleteDependent, setAllAddressFields, setDependent, setUserInfo} from "../actions/userActions";
import Footer from "./footer";
import moment from "moment";
import FormSelectState from "./formSelectState";
import NumberFormat from "react-number-format";
import ErrorEmptyFormInput from "./errorEmptyFormInput"
import ErrorInputAdditionalInfo from "./errorInputAdditionalInfo";
import ChildElegibilityAgreement from "./childElegibilityAgreement";
import {ClickableText, CustomContainer, CustomGrid, CustomModalHeader, DOBInput, SSNInput} from "./custom-common";
import {deleteDependentService, upsertDependentService} from "../services/services";
import {DeleteDependentRequest, UpsertDependentRequest} from "../services/types";

const mapStateToProps = (state, ownProps) => {
    const {user, benAdmin, initialData} = state;
    const {domesticPartnerEligible, civilUnionEligible} = initialData.eligibility;

    const removeValues = [];
    if (!domesticPartnerEligible) removeValues.push(civilUnionText, domesticPartnershipText);
    if (!civilUnionEligible) removeValues.push(civilUnionText);
    const relationshipOptions = initialData.relationshipOptions.filter(opt => !removeValues.includes(opt.value));

    return {
        ...ownProps,
        user,
        dependents: user.dependents,
        initialData, benAdmin,
        eeCensusAddress: initialData.eeCensusAddress,
        childMaxEligibilityAge: initialData.policy.childMaxEligibilityAge,
        lang: user.lang,
        stateOptions: initialData.stateOptions,
        genderOptions: initialData.genderOptions,
        studentStatusOptions: initialData.studentStatusOptions,
        relationshipOptions,
        nameSuffixOptions: initialData.nameSuffixOptions,
        phoneTypeOptions: initialData.phoneTypeOptions,
        streetAddress: user.streetAddress,
        appartment: user.appartment,
        zipCode: user.zipCode,
        city: user.city,
        selectedState: user.selectedState,
        coverageOptions: initialData.coverageOptions,
        coverageOption: user.coverageOption,
        dependentList: user.dependentList.filter(dep => !dep.removedFromPlan).map(dependent => {
            const keys = Object.keys(dependent.address);
            let addressSameAsEmployee = keys.every(key => {
                if (key === 'state') {
                  return dependent.address[key].toLowerCase() === user.selectedState?.toLowerCase();
                } else if (key === 'streetAddress') {
                  const dependentAppartment = dependent.address.appartment;
                  const fullStreetDependent = `${dependent.address[key]} ${dependentAppartment ? `${dependentAppartment}` : ''}`;
                  const fullStreetUser = `${user[key]} ${user.appartment ? `${user.appartment}` : ''}`
                  return fullStreetDependent.trim() === fullStreetUser.trim();
                } else if (key === 'zipCode' || key === 'city') {
                  return dependent.address[key] === user[key]
                } else {
                    return true
                }
              });
            return {
                ...dependent,
                addressSameAsEmployee
            }
        }),
        birthdate: user.birthdate,
        ssn: user.ssn,
        middleName: user.middleName,
        suffix: user.suffix,
        daytimePhoneNumber: user.daytimePhoneNumber,
        phoneType: user.phoneType,
        firstName: user.firstName,
        lastName: user.lastName,
        gender: user.gender,
    }
};

class AdditionalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabledCheckbox: false,
            stepProps: null,
            loadingSpinner: false,
            submitPlanLoading: false,
            openModal: false,
            modalEditMode: false,
            editDependentObjIdx: null,
            openDeleteDependentModal: false,
            needsUserProgressUpdate: false,
            validationErrorsMap: new Map(),
            invalidZipCode: false,
            invalidDepZipCode: false,
            curDependent: {
                showSpouseWarning: false,
                displayChildEligibilityAgreement: false,
                selectedChildButNotAvailable: false,
                selectedSpouseButNotAvailable: false,
                selectedRelationship: '',
                firstName: '',
                middleName: '',
                suffix: '',
                lastName: '',
                birthdate: '',
                gender: '',
                addressSameAsEmployee: !this.disabledCheckBoxAddress(),
                ssn: '',
                ssnError: null,
                relationship: '',
                streetAddress: '',
                appartment: '',
                zipCode: '',
                city: '',
                state: '',
                userAgrees: false,
                dobError: null,
                studentStatus: '',
            },
            showSubmitErrorMessage: false,
            showDependentsSubmitErrorMessage: false,
            curDependentCopy: null,
            dependentUpsertError: '',
            ssnError: null,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin, stateOptions} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        const censusState = this.props.eeCensusAddress.state;
        const sObjList = stateOptions.filter((o) => o.text === censusState);
        const censusAddress = {...this.props.eeCensusAddress};
        if (sObjList.length > 0) {
            censusAddress.state = sObjList[0].value;
        }
        censusAddress.streetAddress = !!censusAddress.street ? censusAddress.street : user.streetAddress;
        censusAddress.appartment = !!censusAddress.appartment ? censusAddress.appartment : user.appartment;
        censusAddress.zipCode = !!censusAddress.zipCode ? censusAddress.zipCode : user.zipCode;
        censusAddress.city = !!censusAddress.city ? censusAddress.city : user.city;
        this.props.dispatch(setAllAddressFields(censusAddress));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 2, uiFlow, distributionChannel)});
    }

    handleChange = (event, {name, value}) => {
        if (name === "SET_ZIP_CODE") {
            const valNum = parseInt(value, 10);
            if (isNaN(valNum) && value !== "") {
                return;
            }
        }
        this.props.dispatch(setUserInfo(name, value));
        this.setState({error: '', needsUserProgressUpdate: true, showSubmitErrorMessage: false});
        this.setError(name, null)
    };

    openModal = (editDependentObj, editDependentObjIdx) => {
        let curDependent = {
            firstName: '',
            middleName: '',
            suffix: '',
            lastName: '',
            relationship: '',
            gender: '',
            ssn: '',
            birthdate: '',
            addressSameAsEmployee: !this.disabledCheckBoxAddress(),
            streetAddress: '',
            appartment: '',
            zipCode: '',
            city: '',
            state: '',
            userAgrees: false,
            showSpouseWarning: false,
            displayChildEligibilityAgreement: false,
            selectedChildButNotAvailable: false,
            selectedSpouseButNotAvailable: false,
            selectedRelationship: '',
            dobError: null,
        }
        if (!!editDependentObj) {
            const {address, ...rest} = editDependentObj;
            curDependent = {...rest, ...address};
        }
        this.setState({
            modalEditMode: !!editDependentObj,
            editDependentObjIdx: editDependentObjIdx,
            openModal: true,
            curDependent: curDependent,
            showDependentsSubmitErrorMessage: false,
            curDependentCopy: curDependent,
            dependentUpsertError: ''
        })
    }

    closeModal = () => {
        this.setState({
            openModal: false,
            editDependentObj: {},
            editDependentObjIdx: null,
            curDependent: {},
        })
    }

    disabledCheckBoxAddress = () => {
        const { user: { city, zipCode, streetAddress } } = this.props;
        return !streetAddress || !zipCode || !city;
      };

    setChildElegibilityUserAgreement = (newValue) => {
        this.setState({
            curDependent: {...newValue},
        });
    }

    renderDependents = (strings, selectedCoverageOption) => {
        let {dependentList} = this.props;
        const opt = selectedCoverageOption[0];
        const hasAddedChild = dependentList.filter(dependent => dependent.relationship === "Child").length > 0;
        const showChildWarning = hasAddedChild && opt.value === "spouse";
        let content;

        const addDependent = <Button primary basic onClick={() => this.openModal()}><b>+ {strings.addDependent}</b></Button>

        const getDependentsForm = (dependentIdx) => {
            let dependent = !!dependentList && dependentList.length >= dependentIdx ? dependentList[dependentIdx] : null;
            return <List.Item as="li" value={`${(dependentIdx + 1)}.`} key={dependentIdx}>
                <Form>
                    <div className={"primaryBoldColor"}>
                        {strings.role}{' '}
                    </div>
                    <Form.Field required>
                        <label>{strings.relationship}</label>
                        <Form.Select disabled={true} value={dependent.relationship}
                                     options={[dependent.relationship].map((r) => {
                                         return {key: r, value: r, text: getTranslatedRelationshipText(r, getLocalization(this.props.lang))}
                                     })}/>
                        {showChildWarning &&
                            <span className={"smaller errorText"}>{strings.coverageNoChild}<Link
                                to={"/plan"} className={"errorText"}
                                style={{textDecoration: 'underline'}}>{strings.goBack}</Link>{strings.andChangeCover}</span>
                        }
                    </Form.Field>
                    <div className={"primaryBoldColor"}>{strings.details}</div>
                    <FormGroup widths={'equal'}>
                        <Form.Field>
                            <label>{strings.firstName}</label>
                            <Form.Input value={dependent.firstName} disabled={true}/>
                        </Form.Field>
                        <Form.Field>
                            <label>{strings.middleName}</label>
                            <Form.Input value={dependent.middleName} disabled={true}/>
                        </Form.Field>
                    </FormGroup>

                    <FormGroup widths={'equal'}>
                        <Form.Field>
                            <label>{strings.lastName}</label>
                            <Form.Input value={dependent.lastName} disabled={true}/>
                        </Form.Field>
                        <Form.Field>
                            <label>{strings.suffix}</label>
                            <Form.Select disabled={true} value={dependent.suffix}
                                         options={[dependent.suffix].map((r, idx) => {
                                             return {key: idx, value: r, text: r}
                                         })}/>
                        </Form.Field>
                    </FormGroup>

                    <FormGroup widths={'equal'}>
                        <DOBInput value={!!dependent.birthdate ? dependent.birthdate : ""} label={strings.dob} isReadonly/>
                        <Form.Field>
                            <label>{strings.gender}</label>
                            <Form.Select disabled={true} value={dependent.gender}
                                         options={[dependent.gender].map((r) => {
                                             return {key: r, value: r, text: getTranslatedGenderText(r, getLocalization(this.props.lang))}
                                         })}/>
                        </Form.Field>
                    </FormGroup>
                    <Form.Group>
                        <SSNInput
                            disabled
                            label={<label>{strings.ssn} <span style={{fontWeight: 'normal'}}>({strings.optional})</span></label>}
                            required={false}
                            value={dependent.ssn}
                            width={6}
                        />
                    </Form.Group>
                    <div className={"primaryBoldColor"}>{strings.address}</div>
                    <FormGroup widths={'equal'}>
                        <Form.Field>
                            <Checkbox label={strings.sameAsEmployee} className={'disabledCheckbox'}
                                      checked={dependent.addressSameAsEmployee}
                                      readOnly={true}/>
                        </Form.Field>
                    </FormGroup>
                    <ClickableText small onClick={() => this.openModal(dependent, dependentIdx)}>
                        {strings.editDetails} <Icon name={'external'} size={'small'}/></ClickableText>
                    {(dependent && !dependent.addressSameAsEmployee) &&
                    <React.Fragment>
                        <FormGroup widths={'equal'}>
                            <Form.Input label={strings.streetAddress} required>
                                {!dependent ? '' : !dependent.address ? '' : dependent.address.streetAddress}
                            </Form.Input>
                            <Form.Input label={strings.aptSuiteOther}>
                                {!dependent ? '' : !dependent.address ? '' : dependent.address.appartment}
                            </Form.Input>
                        </FormGroup>
                        <FormGroup widths={'equal'}>
                            <Form.Input label={strings.zipCode}>
                                {!dependent ? '' : !dependent.address ? '' : dependent.address.zipCode}
                            </Form.Input>
                            <Form.Input label={strings.city} required>
                                {!dependent ? '' : !dependent.address ? '' : dependent.address.city}
                            </Form.Input>
                        </FormGroup>

                        <FormGroup>
                            <Form.Input label={strings.state}>
                                {!dependent ? '' : !dependent.address ? '' : dependent.address.state}
                            </Form.Input>
                        </FormGroup>
                    </React.Fragment>
                    }
                </Form>
                <Divider hidden/>
            </List.Item>;
        }

        content = opt.value !== "employee" ? (
                <React.Fragment>
                    <List as="ol" className={"dependentsList"} relaxed>
                        {!!dependentList && dependentList.map((c, idx) => !!c && getDependentsForm(idx))}
                    </List>
                    {addDependent}
                </React.Fragment>
            ) : (
                <p className={"small"}><i><b>{strings.note}</b> {strings.theCoverageTierDep}</i></p>
            );
        return content;
    }

    handleDependentFormChange = (event, {value, name}) => {
        const {curDependent} = this.state;

        if (name === "zipCode") {
            const valNum = parseInt(value, 10);
            if (isNaN(valNum) && value !== "") {
                return;
            }
        }
        if (name === "birthdate" && value) {
            const {childMaxEligibilityAge} = this.props;
            const displayChildEligibilityAgreement = moment(value, 'MM/DD/YYYY', true).isValid() && moment().diff(value, 'years') >= childMaxEligibilityAge;
            this.setState(
                {
                    curDependent: {
                        ...curDependent,
                        displayChildEligibilityAgreement,
                        dobError: null,
                        [name]: value
                    }
                })
        } else {
            this.setState(
                {
                    curDependent: {
                        ...curDependent,
                        [name]: value
                    }
                })
        }
    }

    displayDeleteDependentModal = () => {
        this.setState({
            openModal: false,
            openDeleteDependentModal: true,
        })
    }

    closeDeleteDependentModal = async (cancelAction) => {
        const localization = getLocalization(this.props.lang);
        const strings = localization.additionalInfo;
        const {modalEditMode, curDependent} = this.state;
        if (!cancelAction) {
            if (modalEditMode) {
                try {
                    this.setState({
                        loadingSpinner: true,
                    })
                    const payload = new DeleteDependentRequest({
                        dependentId: curDependent.id
                    });
                    await deleteDependentService(payload);
                    this.props.dispatch(deleteDependent(curDependent.id));
                    this.setState({
                        loadingSpinner: false,
                    })
                } catch (e) {
                    console.warn(e)
                    this.setState({
                        loadingSpinner: false,
                        dependentUpsertError: strings.requestError
                    })
                }
            }
            this.closeModal();
            this.setState({
                openDeleteDependentModal: false,
            });
        } else {
            this.setState({
                openDeleteDependentModal: false,
                openModal: true,
                dependentUpsertError: ''
            })
        }
    }

    renderDeleteDependentModal = () => {
        const {curDependent, openDeleteDependentModal, loadingSpinner} = this.state;
        const localization = getLocalization(this.props.lang);
        const strings = localization.additionalInfo;
        const firstName = !!curDependent.firstName ? curDependent.firstName : "Unnamed";
        return <Modal size={'tiny'} style={{ maxWidth: '440px' }} onClose={() => this.closeDeleteDependentModal(true)}
        open={openDeleteDependentModal}>
        {loadingSpinner ?
            <div style={{ textAlign: "center", width: '440px', height: '193px' }}>
                <Icon style={{ top: '40%', left: '40%', position: 'absolute' }} name="huge spinner loading icon" disabled />
            </div> :
            <>
                <CustomModalHeader title={strings.confirmDelete} onClose={() => this.closeDeleteDependentModal(true)} />
                <Modal.Content className={"small"}>
                    {strings.dependent} <b>{firstName}</b> {strings.willBeRemoved}
                    <div style={{ paddingTop: '2em' }}>
                        <Button negative primary
                            floated={"right"}
                            onClick={() => {
                                this.closeDeleteDependentModal(false);
                            }}>
                            {strings.delete}
                        </Button>
                        <Button floated={"right"} className={"emptyButton"} onClick={() => this.closeDeleteDependentModal(true)}>
                            {strings.cancel}
                        </Button>
                    </div>
                </Modal.Content>
                <Divider hidden />
            </>
        }
        </Modal>
    }



    renderDependentForm = () => {
        const {curDependent, editDependentObjIdx, modalEditMode, invalidDepZipCode, loadingSpinner} = this.state;
        const {dependentList, lang, stateOptions, genderOptions, relationshipOptions, studentStatusOptions,
            childMaxEligibilityAge, coverageOptions, coverageOption, nameSuffixOptions, initialData} = this.props;
        const {employer} = initialData;
        const {
            relationship, firstName, lastName, birthdate, gender, addressSameAsEmployee, ssn, streetAddress, appartment, city, state, zipCode, userAgrees,
            displayChildEligibilityAgreement, selectedChildButNotAvailable, selectedSpouseButNotAvailable, selectedRelationship, middleName, suffix,
            studentStatus } = curDependent;
        let spouseDependentIdx = null;
        const spouseDependent = dependentList.filter((d, idx) => {
            if (d.relationship === spouseText || d.relationship === domesticPartnershipText || d.relationship === civilUnionText) {
                spouseDependentIdx = idx;
                return true;
            }
            return false;
        });
        const hasSpouseAlready = spouseDependent.length > 0;
        const localization = getLocalization(lang);
        const strings = localization.additionalInfo;
        const error = this.validAddForm();

        const isChild = relationship === "Child";
        const isSpouse = relationship === spouseText || relationship === domesticPartnershipText || relationship === civilUnionText;
        const editingSpouse = editDependentObjIdx === spouseDependentIdx;
        const selectedCoverageOption = coverageOptions.filter((co) => co.value === coverageOption)[0];
        const spouseNotAvailable = selectedCoverageOption.value !== "family" && selectedCoverageOption.value !== "spouse";
        const childNotAvailable = selectedCoverageOption.value !== "family" && selectedCoverageOption.value !== "child";
        const requiresSpouse = selectedCoverageOption.value === "family" || selectedCoverageOption.value === "spouse";
        let filteredRelationshipOptions = relationshipOptions;
        if (hasSpouseAlready && !editingSpouse) {
            filteredRelationshipOptions = relationshipOptions.filter((r) => r.text !== spouseText && r.text !== domesticPartnershipText && r.text !== civilUnionText);
        }
        const disableFields = selectedChildButNotAvailable || selectedSpouseButNotAvailable;
        const isEditting = !!editDependentObjIdx || editDependentObjIdx === 0;

        const handleDOBError = (msg) => {
            if (msg !== curDependent.dobError) {
                this.setState({
                    curDependent: {
                        ...curDependent,
                        dobError: msg,
                    },
                });
            }
        };

        return (
            <>
            {loadingSpinner ?
            <div style={{ textAlign: "center", width: '540px', height: '630px' }}>
                <Icon style={{top: '40%', left: '45%', position: 'absolute'}} name="huge spinner loading icon" disabled />
            </div>
            :
            <Form>
                <Header as="h4">{strings.role}</Header>
                <Form.Field>
                    <Form.Select value={relationship} fluid width={12}
                                 options={filteredRelationshipOptions.map((o) => {
                                     return {
                                         key: o.key, value: o.value, text: getTranslatedRelationshipText(o.text, getLocalization(this.props.lang))
                                     }
                                 })}
                                 name={"relationship"}
                                 required label={strings.relationship}
                                 onFocus={() => {
                                     this.setState({
                                         curDependent: {
                                             ...this.state.curDependent,
                                             selectedSpouseButNotAvailable: false,
                                             selectedChildButNotAvailable: false,
                                             selectedRelationship: '',
                                         }
                                     });
                                 }}
                                 onChange={this.handleDependentFormChange}
                                 onBlur={() => {
                                     if (!!spouseNotAvailable && isSpouse) {
                                         this.setState({
                                             curDependent: {
                                                 ...this.state.curDependent,
                                                 selectedSpouseButNotAvailable: true,
                                                 selectedRelationship: relationship,
                                             }
                                         });
                                     } else if (!!childNotAvailable && isChild) {
                                         this.setState({
                                             curDependent: {
                                                 ...this.state.curDependent,
                                                 selectedChildButNotAvailable: true,
                                                 selectedRelationship: relationship,
                                             }
                                         });
                                     } else {
                                         this.setState({
                                             curDependent: {
                                                 ...this.state.curDependent,
                                                 selectedRelationship: relationship,
                                             }
                                         });
                                     }
                                 }}/>

                    {selectedChildButNotAvailable &&
                    <div className={"smaller errorText"}>
                        {strings.coverageNoChild}
                        <Link to={"/plan"} className={"errorText"} style={{textDecoration: 'underline'}}>{' '}
                            {strings.goBack}
                        </Link>
                        {strings.andChangeCover}
                    </div>
                    }
                    {selectedSpouseButNotAvailable &&
                    <div className={"smaller errorText"}>
                        {strings.coverageNoSpouse}
                        <Link to={"/plan"} className={"errorText"} style={{textDecoration: 'underline'}}>
                            {strings.goBack}
                        </Link>
                        {strings.andChangeCoverCh}
                    </div>
                    }
                    {!hasSpouseAlready && !!requiresSpouse && selectedRelationship === "Child" &&
                        <div className={"smaller errorText"}>
                            {strings.reqSpouse}{' '}{strings.pleaseAddAnother}
                            <Link to={"/plan"} className={"errorText"} style={{textDecoration: 'underline'}}>{' '}
                                {strings.closeAnd}
                            </Link>
                            {strings.changeCover}
                        </div>
                    }
                </Form.Field>
                <Header as="h4">{strings.details}</Header>
                <Form.Group widths="equal">
                    <ErrorEmptyFormInput fluid required={true}
                                         label={strings.firstName}
                                         name='firstName'
                                         disabled={disableFields}
                                         value={!firstName ? '' : firstName}
                                         onChange={this.handleDependentFormChange}/>

                    <ErrorEmptyFormInput fluid
                                         label={strings.middleName}
                                         name='middleName'
                                         disabled={disableFields}
                                         value={!middleName ? '' : middleName}
                                         onChange={this.handleDependentFormChange}/>
                </Form.Group>

                <Form.Group widths="equal">
                    <ErrorEmptyFormInput fluid required={true}
                                         label={strings.lastName}
                                         name='lastName'
                                         disabled={disableFields}
                                         value={!lastName ? '' : lastName}
                                         onChange={this.handleDependentFormChange}/>

                    <Form.Select value={!suffix ? '' : suffix}
                                 fluid
                                 options={nameSuffixOptions} name={"suffix"}
                                 label={strings.suffix}
                                 onChange={this.handleDependentFormChange}/>
                </Form.Group>

                <Form.Group widths="equal">
                    <Form.Field required>
                        <DOBInput value={!!birthdate ? birthdate : ''} fluid
                                  name={"birthdate"}
                                  label={strings.dob}
                                  setFormError={handleDOBError}
                                  onChange={(event, {value}) => {
                                      this.handleDependentFormChange(event, {value, name: 'birthdate'});
                                  }}
                                  required
                        />
                    </Form.Field>

                    <Form.Select fluid required label={strings.gender} disabled={disableFields}
                                 value={gender}
                                 name={"gender"}
                                 options={genderOptions.map((o)=>{
                                     return {key: o.key, value: o.value, text: getTranslatedGenderText(o.text, getLocalization(this.props.lang))}
                                 })}
                                 onChange={this.handleDependentFormChange}
                    />
                </Form.Group>

                <Form.Group>
                    <SSNInput
                        disabled={disableFields}
                        label={<label>{strings.ssn} <span style={{fontWeight: 'normal'}}>({strings.optional})</span></label>}
                        name={"ssn"}
                        onChange={(e, value) => this.handleDependentFormChange(e, {value, name: "ssn"})}
                        required={false}
                        setSSNError={(hasError) => {
                            const dep = curDependent;
                            dep.ssnError = hasError;
                            this.setState({
                                curDependent: {...dep},
                            })
                        }}
                        value={ssn}
                        width={6}
                    />
                    { isChild && employer.address.state === "FL" &&
                    <Form.Select label={<label>{strings.studentStatus}</label>}
                                width={6} value={studentStatus} name={"studentStatus"}
                                disabled={disableFields}
                                options={studentStatusOptions.map((o)=>{
                                    return {key: o.key, value: o.value, text: getTranslatedStudentStatusText(o.text, getLocalization(this.props.lang))}
                                })}
                                onChange={this.handleDependentFormChange}
                                />
                    }
                </Form.Group>

                <Header as="h4">{strings.address}</Header>
                <Form.Group>
                    <Form.Field width={6}>
                        <Checkbox disabled={this.disabledCheckBoxAddress()} label={strings.sameAsEmployee}
                                  name={"addressSameAsEmployee"}
                                  checked={addressSameAsEmployee}
                                  onChange={(e) => {
                                      this.handleDependentFormChange(e, {
                                          name: "addressSameAsEmployee",
                                          value: !addressSameAsEmployee
                                      })
                                  }}
                        />
                    </Form.Field>
                </Form.Group>

                {!addressSameAsEmployee &&
                <React.Fragment>
                    <FormGroup widths={'equal'}>
                        <ErrorEmptyFormInput fluid required={true}
                                             label={strings.streetAddress}
                                             name='streetAddress'
                                             disabled={disableFields}
                                             value={!streetAddress ? '' : streetAddress}
                                             onChange={this.handleDependentFormChange}/>

                        <Form.Input label={strings.aptSuiteOther} disabled={disableFields}
                                    value={!appartment ? '' : appartment}
                                    name={"appartment"} onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                    <FormGroup widths={'equal'}>
                        <Form.Field>
                            <Form.Input label={strings.zipCode} required
                                        value={!zipCode ? '' : zipCode}
                                        error={invalidDepZipCode}
                                        name={"zipCode"}
                                        onFocus={() => {
                                            this.setState({
                                                invalidDepZipCode: false,
                                            });
                                        }}
                                        onChange={this.handleDependentFormChange}
                                        onBlur={() => {
                                            const isError = !zipCode || zipCode.length === 0 || ((zipCode.length > 5 && zipCode.length < 9) || zipCode.length < 5 || zipCode.length > 9);
                                            this.setState({
                                                invalidDepZipCode: isError || isNaN(zipCode * 1),
                                            })
                                        }}/>
                            {!!invalidDepZipCode && <small className={'errorText'}>{strings.invalidZipCode}</small>}
                        </Form.Field>

                        <ErrorEmptyFormInput fluid required={true}
                                             label={strings.city}
                                             name='city'
                                             disabled={disableFields}
                                             value={!city ? '' : city}
                                             onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                    <FormGroup>
                        <FormSelectState name={"state"}
                                         initialValue={state}
                                         options={stateOptions}
                                         disabled={disableFields}
                                         onChange={this.handleDependentFormChange}/>
                    </FormGroup>
                </React.Fragment>
                }

                <ChildElegibilityAgreement
                    strings={strings}
                    isEditting={isEditting}
                    childMaxEligibilityAge={childMaxEligibilityAge}
                    birthdate={birthdate}
                    studentStatus={studentStatus}
                    isChild={isChild}
                    curDependent={this.state.curDependent}
                    setUserAgrees={this.setChildElegibilityUserAgreement}
                    employer={employer}
                />

                <CustomContainer basic vertical clearing style={{paddingBottom: 0}}>
                    {isEditting &&
                    <Button basic floated={"left"}
                            style={{boxShadow: '0px 0px 0px 1px transparent inset', paddingLeft: 0}}
                            onClick={() => {
                                this.displayDeleteDependentModal(modalEditMode);
                            }}>
                        <span className={"errorText"}><b>{strings.delete}</b></span>
                    </Button>}

                    <Button primary
                            disabled={!!error || invalidDepZipCode || curDependent.dobError || curDependent.ssnError ||
                                (!!isEditting && !!isChild && moment().diff(birthdate, 'years') >= childMaxEligibilityAge && !userAgrees) ||
                                (!!displayChildEligibilityAgreement && !!isChild && !userAgrees)  ||
                                (!!childNotAvailable && isChild) || !!selectedSpouseButNotAvailable || !!selectedChildButNotAvailable
                            }
                            floated={"right"}
                            onClick={() => {
                                if (modalEditMode) {
                                    this.editDependent(curDependent);
                                } else {
                                    this.submitNewDependent();
                                }
                            }}>
                        {strings.save}
                    </Button>
                    <Button className={"emptyButton"} floated={"right"} onClick={this.closeModal}>{strings.cancel}</Button>
                </CustomContainer>
                {!!this.state.dependentUpsertError &&
                            <CustomGrid.Column><Divider hidden />
                                <Message negative>{this.state.dependentUpsertError}</Message>
                            </CustomGrid.Column>}
            </Form>
            }
            </>
        )
    }

    validAddForm = () => {
        const {curDependent} = this.state;
        const required = ['firstName', 'lastName', 'birthdate', 'gender', 'relationship'];
        let error = false;

        for (let i = 0; i < required.length; i++) {
            let item = required[i];
            if (!curDependent[item] || curDependent[item].length === 0) {
                error = true;
                break;
            }
        }

        if (!curDependent.addressSameAsEmployee) {
            const requiredIfAddress = ['streetAddress', 'zipCode', 'city', 'state'];
            for (let i = 0; i < requiredIfAddress.length; i++) {
                let item = requiredIfAddress[i];
                if (!curDependent[item] || curDependent[item].length === 0) {
                    error = true;
                    break;
                }
            }
        }

        return error;
    }

    sanitazeDependent = (dependent) => {
        const d = {
            ...dependent,
            birthdate: moment(dependent.birthdate).format('YYYY-MM-DD'),
            id: dependent.id ? dependent.id : null,
            socialSecurityNumber: dependent.ssn,
        }
        delete d['addressSameAsEmployee']
        delete d['isQualifiedForCoverage']
        delete d['dobError']

        return d;
    }

    upsertDependent = async (dependent) => {
        const {lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.additionalInfo;
        const checkFieldsConstraints = dependent.id ? this.checkFieldsConstraints(dependent, this.state.curDependentCopy) : null;
        const duplicateDependent = this.checkDupDependent(dependent);

        if (!!checkFieldsConstraints || duplicateDependent) {
            this.setState({
                loadingSpinner: false,
                dependentUpsertError: checkFieldsConstraints || strings.duplicateDependent
            });
            return;
        }
        try {
            this.setState({
                loadingSpinner: true,
            })
            const payload = new UpsertDependentRequest({
                token: this.props.initialData.token,
                dependent: this.sanitazeDependent(dependent),
                languageCode: lang,
            });
            const data = await upsertDependentService(payload);
            this.setState({
                loadingSpinner: false,
            })

            return data;
        } catch (e) {
            this.setState({
                loadingSpinner: false,
                dependentUpsertError: e?.response?.data?.errorMessage ?? strings.requestError,
            })
        }
    }

    getAddress = (dependent) => {
        const { user } = this.props;
        const address = dependent.addressSameAsEmployee ? user : dependent;
        const {streetAddress, appartment, zipCode, city, state, selectedState} = address;
        return {
          streetAddress,
          appartment,
          zipCode,
          city,
          state: dependent.addressSameAsEmployee ? selectedState : state
        };
    };

    submitNewDependent = async () => {
        const {curDependent} = this.state;
        const dependent = {
            ...curDependent,
            address: this.getAddress(curDependent),
            isQualifiedForCoverage: curDependent.userAgrees,
        }
        const res = await this.upsertDependent(dependent);
        if (!res) {
            return
        }
        dependent.id = res.rosterFamilyMemberId;
        this.props.dispatch(setDependent(dependent));
        this.closeModal();
        this.setState({needsUserProgressUpdate: true});
    }

    editDependent = async (dependentObj) => {
        const dependent = {
            ...dependentObj,
            address: this.getAddress(dependentObj),
            isQualifiedForCoverage: !!dependentObj.userAgrees ? dependentObj.userAgrees : false,
        }

        const res = await this.upsertDependent(dependent);
        if (!res) {
            return;
        }
        this.props.dispatch(setDependent(dependent));
        this.closeModal();
        this.setState({needsUserProgressUpdate: true});
    }

    checkFieldsConstraints(curDependent, curDependentCopy) {
        const localization = getLocalization(this.props.lang);
        const strings = localization.additionalInfo;
        if (curDependentCopy.ssn) {
            if (curDependent.ssn !== curDependentCopy.ssn) {
                return strings.ssnUpdateError;
            } else if (curDependent.firstName !== curDependentCopy.firstName) {
                return strings.firstNameUpdateError;
            } else if (curDependent.lastName !== curDependentCopy.lastName) {
                return strings.lastNameUpdateError;
            } else if (curDependent.birthdate !== curDependentCopy.birthdate) {
                return strings.birthdateUpdateError;
            } else if (curDependent.relationship !== curDependentCopy.relationship) {
                return strings.roleUpdateError;
            }
        }

        return null;
    }

    checkDupDependent = (dependent) => {
        const { dependentList } = this.props;
        return dependentList.some(dp =>
            dp.id !== dependent.id &&
            ((dp.ssn && dp.ssn === dependent.ssn) ||
            (!dp.ssn && dp.firstName === dependent.firstName && dp.lastName === dependent.lastName &&
            dp.birthdate === dependent.birthdate && dp.relationship === dependent.relationship))
        );
    }

    validate = () => {
        const required = ['firstName', 'lastName', 'birthdate', 'ssn', 'daytimePhoneNumber', 'phoneType', 'streetAddress', 'city', 'zipCode', 'selectedState', 'gender'];
        let error = false;

        for (let i = 0; i < required.length; i++) {
            let item = required[i];
            if (!this.props.user[item] || this.props.user[item].length === 0) {
                error = true;
                break;
            }
        }
        let newMap = new Map();
        newMap["firstName"] = "SET_FIRST_NAME"
        newMap["lastName"] = "SET_LAST_NAME"
        newMap["daytimePhoneNumber"] = "SET_DAYTIME_PHONE"
        newMap["phoneType"] = "SET_PHONE_TYPE"
        newMap["streetAddress"] = "SET_STREET_ADDRESS"
        newMap["city"] = "SET_CITY"
        newMap["zipCode"] = "SET_ZIP_CODE"
        newMap["selectedState"] = "SET_SELECTED_STATE"
        newMap["gender"] = "SET_GENDER"

        for (let i = 0; i < required.length; i++) {
            let item = required[i];
            if (!this.props.user[item] || this.props.user[item] === null || this.props.user[item].length === 0) {
                this.setError(newMap[item], this.props.lang === languages.ENGLISH ? "Required" : "Requerido");
            }
        }
        return error;
    }

    getError = (key) => {
        const vem = this.state.validationErrorsMap;
        if (!!vem) {
            return vem.get(key);
        }
        return null;
    }

    setError = (key, msg) => {
        const {validationErrorsMap} = this.state;
        validationErrorsMap.set(key, msg)
        this.setState({
            validationErrorsMap,
        })
    }

    submit = () => {
        const {invalidZipCode, invalidDepZipCode, validationErrorsMap, needsUserProgressUpdate} = this.state;
        const error = this.validate();
        const hasErrors = invalidZipCode || invalidDepZipCode || error || validationErrorsMap.length > 0;
        const {coverageOptions, coverageOption, dependentList, initialData} = this.props;
        const selectedCoverageOption = coverageOptions.filter((co) => co.value === coverageOption);
        const opt = selectedCoverageOption[0];
        const noSpouse = dependentList.filter(dependent => dependent.relationship === spouseText || dependent.relationship === domesticPartnershipText || dependent.relationship === civilUnionText).length === 0;
        const showSpouseWarning = noSpouse && (opt.value === "family" || opt.value === "spouse");
        const hasAddedChild = dependentList.filter(dependent => dependent.relationship === "Child").length > 0;
        const childMissing = !hasAddedChild && (opt.value === "family" || opt.value === "child");
        const dependentsError = showSpouseWarning || (hasAddedChild && opt.value === "spouse") || childMissing

        if (!hasErrors && !dependentsError) {
            if(needsUserProgressUpdate){
                handleSaveUserProgress(initialData.token, this.props.user).then();
            }
            this.props.history.push(this.props.nextRoute)
        } else {
            if (hasErrors) {
                this.setState({
                    showSubmitErrorMessage: true
                })
            }
            if (dependentsError) {
                this.setState({
                    showDependentsSubmitErrorMessage: true
                })
            }
        }
    }

    renderErrorMessage = (strings) => {
        let content;
        if(!this.state.showDependentsSubmitErrorMessage && !this.state.showSubmitErrorMessage){
            return null;
        } else if (this.state.showDependentsSubmitErrorMessage && this.state.showSubmitErrorMessage){
            content = <>
                <p className='messageList smaller'><b>{strings.genericErrTitle}</b></p>
                <ul className='messageList'>
                    <li className='smaller'>{strings.genericErr}</li>
                    <li className='smaller'>{strings.dependentErr}</li>
                </ul>
            </>
        } else if(this.state.showDependentsSubmitErrorMessage){
            content= <p className='smaller'><b>{strings.genericErrTitle}</b> {strings.dependentErr}</p>
        } else {
            content= <p className='smaller'><b>{strings.genericErrTitle}</b> {strings.genericErr}</p>
        }
        return <CustomGrid.Column className='messageContainer'>
            <CustomContainer basic className='label-bkgWarning50'>
                {content}
            </CustomContainer>
        </CustomGrid.Column>
    }

    render() {
        const {
            selectedState, streetAddress, appartment, zipCode, city, coverageOptions, coverageOption, birthdate, ssn, middleName, genderOptions,
            suffix, daytimePhoneNumber, phoneType, stateOptions, firstName, lastName, phoneTypeOptions, nameSuffixOptions, dependentList, gender, initialData
        } = this.props;
        const {stepProps, openModal, openDeleteDependentModal, invalidZipCode, editDependentObjIdx} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.additionalInfo;

        const selectedCoverageOption = coverageOptions.filter((co) => co.value === coverageOption);
        let displayTier = "";
        if (!!selectedCoverageOption && selectedCoverageOption.length > 0) {
            displayTier = getTranslatedCoverageText(selectedCoverageOption[0].value, localization);
        }
        const opt = selectedCoverageOption[0];
        const noSpouse = dependentList.filter(dependent => dependent.relationship === spouseText || dependent.relationship === domesticPartnershipText || dependent.relationship === civilUnionText).length === 0;
        const showSpouseWarning = noSpouse && (opt.value === "family" || opt.value === "spouse");
        const hasAddedChild = dependentList.filter(dependent => dependent.relationship === "Child").length > 0;
        const childMissing = !hasAddedChild && (opt.value === "family" || opt.value === "child");
        const isFamilyTier = opt.value === "family";
        const sObjList = stateOptions.filter((o) => o.value === selectedState);
        let selectedStateLabel = selectedState;
        if (sObjList.length > 0) {
            selectedStateLabel = sObjList[0].text;
        }

        let displayAgeReduction = false;
        const {ageReduction, ageReductionAge, polEDate, ageReductionPercentage} = initialData.policy;
        const isEditting = !!editDependentObjIdx || editDependentObjIdx === 0;
        if(ageReduction){
            const dependents = dependentList.filter(dependent => moment(polEDate).diff(moment(dependent.birthdate), "years") >= ageReductionAge);
            if(dependents.length > 0){
                displayAgeReduction = true;
            }
        }

        return (
            <React.Fragment>
                {!!openModal && <Modal size={'tiny'} onClose={this.closeModal} open={openModal}>
                    <CustomModalHeader title={isEditting ? strings.editDependent : strings.addDependent} onClose={this.closeModal}/>
                    <Modal.Content className={"small"}>
                        {this.renderDependentForm()}
                    </Modal.Content>
                </Modal>}
                {!!openDeleteDependentModal && this.renderDeleteDependentModal()}
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable container>
                                <CustomContainer basic textAlign={'left'}>
                                    <b>{strings.yourTier}{': '}</b> {displayTier}
                                    <Header as='h2'>{strings.title}</Header>
                                    <CustomContainer basic className={"additionalInfoLightBackground small"}>
                                        <p>{strings.theGreyedOut}</p>
                                    </CustomContainer>
                                </CustomContainer>
                                <CustomGrid.Row columns={1}>
                                    <CustomGrid.Column>
                                        <Header as={'h4'}>{strings.yourDetails}</Header>
                                        <Form>
                                            <FormGroup widths={'equal'}>
                                                <ErrorInputAdditionalInfo fluid required={true}
                                                                          error={!!this.getError('SET_FIRST_NAME')}
                                                                          label={strings.firstName}
                                                                          name='SET_FIRST_NAME'
                                                                          value={!firstName ? '' : firstName}
                                                                          onChange={this.handleChange}/>

                                                <Form.Input label={strings.middleName}
                                                            value={!middleName ? '' : middleName}
                                                            name={"SET_MIDDLE_NAME"} onChange={this.handleChange}
                                                />
                                            </FormGroup>
                                            <FormGroup widths={'equal'}>
                                                <ErrorInputAdditionalInfo fluid required={true}
                                                                          label={strings.lastName}
                                                                          error={!!this.getError('SET_LAST_NAME')}
                                                                          name='SET_LAST_NAME'
                                                                          value={!lastName ? '' : lastName}
                                                                          onChange={this.handleChange}/>
                                                <Form.Select value={!suffix ? '' : suffix}
                                                             fluid
                                                             options={nameSuffixOptions} name={"SET_SUFFIX"}
                                                             label={strings.suffix}
                                                             onChange={this.handleChange}/>
                                            </FormGroup>
                                            <FormGroup widths={'equal'}>
                                                <DOBInput value={!!birthdate ? birthdate : ""} label={strings.dob} isReadonly required visibilityIconVisible={true}/>
                                                <Form.Field required error={!!this.getError('SET_GENDER')}>
                                                    <label>{strings.gender }</label>
                                                    <Select value={gender}
                                                            name={"SET_GENDER"}
                                                            options={genderOptions.map((o)=>{
                                                                return {key: o.key, value: o.value, text: getTranslatedGenderText(o.text, getLocalization(this.props.lang))}
                                                            })}
                                                            onChange={this.handleChange}
                                                    />
                                                    {!!this.getError('SET_GENDER') && <small
                                                        className={"errorText"}>{this.getError('SET_GENDER')}</small>}
                                                </Form.Field>
                                            </FormGroup>
                                            <FormGroup widths={'equal'}>
                                                <Form.Field>
                                                    <NumberFormat format="(###) ###-####" placeholder="(XXX) XXX-XXXX"
                                                                  name={"SET_DAYTIME_PHONE"}
                                                                  error={!!this.getError('SET_DAYTIME_PHONE')}
                                                                  onFocus={() => {
                                                                      if (!!this.getError('SET_DAYTIME_PHONE')) {
                                                                          this.setError('SET_DAYTIME_PHONE', null);
                                                                      }
                                                                  }}
                                                                  required={true} fluid
                                                                  label={strings.daytimePhone}
                                                                  customInput={Form.Input}
                                                                  value={!daytimePhoneNumber ? '' : daytimePhoneNumber}
                                                                  onBlur={(e) => {
                                                                      const value = e.target.value;
                                                                      if (!value || value.trim().length < "(###) ###-####".length) {
                                                                          this.setError('SET_DAYTIME_PHONE', strings.invalidPhoneNumber);
                                                                      }
                                                                      this.handleChange(e, {
                                                                          name: 'SET_DAYTIME_PHONE',
                                                                          value
                                                                      })
                                                                  }}/>
                                                    {!!this.getError('SET_DAYTIME_PHONE') && <small
                                                        className={"errorText"}>{this.getError('SET_DAYTIME_PHONE')}</small>}
                                                </Form.Field>
                                                <Form.Field required error={!!this.getError('SET_PHONE_TYPE')}>
                                                    <label>{strings.phoneType}</label>
                                                    <Select value={!phoneType ? '' : phoneType}
                                                            options={phoneTypeOptions.map((o)=>{
                                                                return {key: o.key, value: o.value, text: getTranslatedPhoneTypeText(o.text, getLocalization(this.props.lang))
                                                            }})}
                                                            name={"SET_PHONE_TYPE"}
                                                            onChange={this.handleChange}/>
                                                    {!!this.getError('SET_PHONE_TYPE') && <small
                                                        className={"errorText"}>{this.getError('SET_PHONE_TYPE')}</small>}
                                                </Form.Field>
                                            </FormGroup>
                                            <Form.Group>
                                                <SSNInput
                                                    disabled
                                                    label={strings.ssn}
                                                    required
                                                    value={!!ssn ? ssn : ''}
                                                    width={6}
                                                    visibilityIconVisible={true}
                                                />
                                            </Form.Group>
                                        </Form>
                                        <Divider hidden/>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column>
                                        <Header as={'h4'}>{strings.homeAddress}</Header>
                                        <Form>
                                            <FormGroup widths={'equal'}>
                                                <ErrorInputAdditionalInfo required={true}
                                                                          error={!!this.getError('SET_STREET_ADDRESS')}
                                                                          label={strings.streetAddress}
                                                                          name='SET_STREET_ADDRESS'
                                                                          value={!streetAddress ? '' : streetAddress}
                                                                          onChange={this.handleChange}/>

                                                <Form.Input label={strings.aptSuiteOther}
                                                            value={!appartment ? '' : appartment}
                                                            name={"SET_APPARTMENT"} onChange={this.handleChange}/>
                                            </FormGroup>
                                            <FormGroup widths={'equal'}>
                                                <Form.Field>
                                                    <Form.Input label={strings.zipCode} required
                                                                value={!zipCode ? '' : zipCode}
                                                                error={invalidZipCode || !!this.getError('SET_ZIP_CODE')}
                                                                name={"SET_ZIP_CODE"}
                                                                onFocus={() => {
                                                                    this.setState({
                                                                        invalidZipCode: false,
                                                                    });
                                                                }}
                                                                onChange={this.handleChange}
                                                                onBlur={() => {
                                                                    const isError = !zipCode || zipCode.length === 0 || ((zipCode.length > 5 && zipCode.length < 9) || zipCode.length < 5 || zipCode.length > 9);
                                                                    this.setState({
                                                                        invalidZipCode: isError || isNaN(zipCode * 1),
                                                                    })
                                                                }}/>
                                                    {!!invalidZipCode &&
                                                    <small className={'errorText'}>{strings.invalidZipCode}</small>}
                                                    {!!this.getError('SET_ZIP_CODE') && <small
                                                        className={"errorText"}>{this.getError('SET_ZIP_CODE')}</small>}
                                                </Form.Field>


                                                <ErrorInputAdditionalInfo required={true}
                                                                          error={!!this.getError('SET_CITY')}
                                                                          label={strings.city}
                                                                          name='SET_CITY'
                                                                          value={!city ? '' : city}
                                                                          onChange={this.handleChange}/>
                                            </FormGroup>
                                            <FormGroup>
                                                <Form.Field width={6} required>
                                                    <label>{strings.state}</label>
                                                    <Form.Input value={!selectedStateLabel ? '' : selectedStateLabel}
                                                                disabled={true}
                                                                fluid name={"SET_SELECTED_STATE"}
                                                                onChange={this.handleChange}/>
                                                </Form.Field>
                                            </FormGroup>
                                        </Form>
                                        <Divider hidden/>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column>
                                    <Header as={'h4'}>{strings.dependents}</Header>
                                    <div>
                                        {!!displayAgeReduction && <React.Fragment>
                                        <CustomContainer basic className={"lightBackground small"}>
                                        <b>{strings.important}</b>: {interpolateString(strings.basedOnDependentAge, [ageReductionPercentage])}
                                        </CustomContainer>
                                        <Divider hidden />
                                        </React.Fragment>}
                                        {this.renderDependents(strings, selectedCoverageOption)}
                                    </div>
                                        </CustomGrid.Column>
                                    {isFamilyTier && (childMissing || showSpouseWarning) && <CustomGrid.Column className='messageContainer'>
                                        {childMissing && showSpouseWarning && <small className='dependentNoteText'>
                                            <b>{strings.note}</b> {strings.reqSpouseChild}</small>}
                                        {showSpouseWarning && !childMissing &&
                                        <small className='dependentNoteText'><b>{strings.note}</b> {strings.reqSpouse}
                                        </small>}
                                        {childMissing && !showSpouseWarning &&
                                        <small className='dependentNoteText'><b>{strings.note}</b> {strings.reqChild}
                                        </small>}
                                    </CustomGrid.Column>}
                                    {!isFamilyTier && (childMissing || showSpouseWarning) && <CustomGrid.Column className='messageContainer'>
                                        {showSpouseWarning &&
                                        <small className='dependentNoteText'><b>{strings.note}</b> {strings.reqSpouse}
                                        </small>}
                                        {childMissing && !showSpouseWarning &&
                                        <small className='dependentNoteText'><b>{strings.note}</b> {strings.reqChild}
                                        </small>}
                                    </CustomGrid.Column>}
                                    {this.renderErrorMessage(strings)}
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={this.submit}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(AdditionalInfo));
